import React, { useState } from "react";
import "../styles/Adminproducts.css";
import ProductList from "./Productslist";
import CreateProduct from "./CreateProduct";
import SpecificationDetails from "./specification";
import CsvUpload from "./uploadcsv";
import BannerUpload from "./bannerupload";
import DisplayCoupons from "../discounts/Coupons";

const ImportExport = () => <div>Import Export</div>;

const Adminproducts = () => {
  const [selectedTab, setSelectedTab] = useState("home");

  const [product, setProduct] = useState({
    name: "",
    sku: "",
    price: "",
    category: "",
  });

  return (
    <div className="container-fluid">
      {/* ---------- TOP TABS ---------- */}
      <div className="product-tabs">
        <button
          className={selectedTab === "home" ? "active" : ""}
          onClick={() => setSelectedTab("home")}
        >
          Prod-List
        </button>
        <button
          className={selectedTab === "profile" ? "active" : ""}
          onClick={() => setSelectedTab("profile")}
        >
          Create-Prod
        </button>
        <button
          className={selectedTab === "about" ? "active" : ""}
          onClick={() => setSelectedTab("about")}
        >
          specifications
        </button>
        <button
          className={selectedTab === "contact" ? "active" : ""}
          onClick={() => setSelectedTab("contact")}
        >
          Upload-Csv
        </button>
        <button
          className={selectedTab === "contact2" ? "active" : ""}
          onClick={() => setSelectedTab("contact2")}
        >
          import/export
        </button>
        <button
          className={selectedTab === "contact3" ? "active" : ""}
          onClick={() => setSelectedTab("contact3")}
        >
          upload-banner
        </button>
        <button
          className={selectedTab === "contact4" ? "active" : ""}
          onClick={() => setSelectedTab("contact4")}
        >
          grid-display
        </button>
      </div>

      {/* ---------- HEADER + FILTERS ---------- */}

      {/* ---------- TAB CONTENT ---------- */}
      <div className="tab-content bg-white">
        {selectedTab === "home" && (
          <div className="table-wrapper">
            <ProductList />
          </div>
        )}

        {selectedTab === "profile" && <CreateProduct />}

        {selectedTab === "about" && <SpecificationDetails />}
        {selectedTab === "contact" && <CsvUpload />}
        {selectedTab === "contact2" && <ImportExport />}
        {selectedTab === "contact3" && <BannerUpload />}
        {selectedTab === "contact4" && <DisplayCoupons />}
      </div>
      <style>{`.product-tabs {
  display: flex;
  flex-wrap: wrap;        /* ✅ allows next line instead of overflow */
  gap: 10px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
}
`}</style>
    </div>
  );
};

export default Adminproducts;
